export default "__VITE_ASSET__DivRRJv2__"